// Components
import DatePicker from "vue2-datepicker"

// Service
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { comingSoonMixins } from "@/app/mixins/utils/coming-soon-mixins"

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

const DOG_GENDER = {
	DAM: "Dam",
	SIRE: "Sire",
}

export default {
    name: 'DamSireListContainer',
    components: {
        DatePicker
    },
    directive: {},
    filters: {},
    mixins: [
        tableMixins,
        dateMixins,
        toastMessageMixins,
        comingSoonMixins
    ],
    props: {},
    data() {
        return {
            ADD_DAM_SIRE_PATH: BREEDER_ROUTES.ADD_DAM_SIRE,
            isAPILoading: false,
            // Gender List
            genderList:[{
					value: "dam",
					name: "Dam",
				},
				{
					value: "sire",
					name: "Sire",
				}],
            selectGender:'',
			limit: 9,
			// pagination
			page: 1,
			pageCount: 0,
			totalCount: 0,
			// sorting
			sortBy: '',
			desc: true,
			columnsFilter: {},
			genderOptions: [DOG_GENDER.DAM, DOG_GENDER.SIRE],
			dogName: '',
			breedName: '',

			isShowMore: false,
			damSireListTotalCount: 0,
			damSireList: [],
			BREEDER_ROUTES,
			DOG_GENDER,
			didFetchList: false,
        }
    },
    computed: {
		displayShowMoreButton() {
			return this.damSireListTotalCount != this.damSireList.length;
		}
	},
    watch: {
        selectGender() {
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc, true)
		},

    },
    created() {
        this.getTableContent()
    },
    methods: {
        getTableContent(
			page = this.page,
			limit = this.limit,
			sortBy = this.sortBy,
			desc = this.desc,
			fromFilter = false
		) {
			page = fromFilter ? 1 : this.page
			limit = 9; // max limit per call
			this.callDamAndSireListAPI({ page, limit, sortBy, desc })
		},
			
		callDamAndSireListAPI(queryParams) {
			this.isAPILoading = true

			if (this.columnsFilter) {
				if (this.columnsFilter.f_dogName) {
					queryParams["f_dogName"] = this.columnsFilter.f_dogName
				}
                if (this.columnsFilter.f_breedName) {
					queryParams["f_breedName"] = this.columnsFilter.f_breedName
				}
			}

			if (this.selectGender) {
				queryParams["f_gender"] = this.selectGender
			}

			breedingManagementService.getBreederDamAndSireList(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {

						if (this.isShowMore) {
							this.damSireList = [...this.damSireList, ...res.data.data]
							this.isShowMore = false
						} else {
							this.damSireList = res.data.data
						}
						
						
						this.damSireListTotalCount = res.data.pagination.totalCount
					} else {
						this.showAPIErrorToast(this.toastMessages.litters().ERROR_GET_LITTER_LIST, res)
					}

					this.didFetchList = true
					this.isAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
		showMore() {
			this.isShowMore = true
			this.onPageSelected("next")
		},
		capitalizeFirstLetter(word) {
			if (typeof word !== 'string' || word.length === 0) {
				return word; 
			}
			return word.charAt(0).toUpperCase() + word.slice(1);
		},
		redirectToAddDamSire () {
			this.$router.push(`${BREEDER_ROUTES.ADD_DAM_SIRE}`);
		},
		puppyImage(image) {
            return image ? image : require("@/assets/images/_shared/dog-purchase.png");
        },
		setSelectedFilter(filterBy, event) {
			this.page = 1;
			this.isShowMore = false;

			this.onDropdownFilter(filterBy, event);
		},
		redirectTo (route, damSireId) {
			if(!damSireId){
				return;
			}

			const queryParam = route === BREEDER_ROUTES.EDIT_MATING ? `dam=${damSireId}` : `id=${damSireId}`;
			this.$router.push(`${route}?${queryParam}&from=dam-sire-list`);
		},
		
    },
    // third party libraries
}